import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { compact } from 'lodash-es';
import { getTestIds } from '../../../../utils/TestIds';
import { Searchbox } from '../../../Searchbox';
import { SortableList } from '../../../SortableList';
import { Typography } from '../../../Typography';
import styles from './ColumnsPanel.module.scss';
import { inRowOrder } from './ColumnsPanel.utils';
import { ColumnsPanelRow } from './ColumnsPanelRow';
export function ColumnsPanel(param) {
    let { searchPlaceholder, noMatchText, lockedTooltip, entries, bi, onToggleVisibility, onReorder, maxHeight, testId } = param;
    const testIds = useMemo(()=>getTestIds(testId), [
        testId
    ]);
    const [search, setSearch] = useState('');
    const [rowOrder, setRowOrder] = useState(()=>entries.map((param)=>{
            let { id } = param;
            return id;
        }));
    const query = search.trim().toLowerCase();
    const rows = inRowOrder(entries, rowOrder);
    const mainEntry = rows.find((entry)=>entry.isMain);
    const reorderableEntries = rows.filter((entry)=>!entry.isMain);
    const matchingEntries = rows.filter((entry)=>entry.label.toLowerCase().includes(query));
    const panelRow = (entry)=>/*#__PURE__*/ _jsx(ColumnsPanelRow, {
            entry: entry,
            lockedTooltip: lockedTooltip,
            toggleBi: bi.toggleVisibility,
            onToggleVisibility: onToggleVisibility,
            testId: testId
        });
    const searchResults = matchingEntries.length === 0 ? /*#__PURE__*/ _jsx(Typography, {
        variant: "paragraph2",
        skin: "secondary",
        className: styles.noMatch,
        testId: testIds.noMatch(),
        children: noMatchText
    }) : matchingEntries.map((entry)=>/*#__PURE__*/ _jsx("div", {
            className: styles.staticEntry,
            children: panelRow(entry)
        }, entry.id));
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.panel,
        style: {
            maxHeight
        },
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.searchHeader,
                children: /*#__PURE__*/ _jsx(Searchbox, {
                    fluidWidth: true,
                    value: search,
                    placeholder: searchPlaceholder,
                    bi: bi.search,
                    onChange: (event)=>setSearch(event.target.value),
                    onClear: ()=>setSearch(''),
                    testId: testIds.search()
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.list,
                children: query !== '' ? searchResults : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        mainEntry != null && /*#__PURE__*/ _jsx("div", {
                            className: styles.staticEntry,
                            children: panelRow(mainEntry)
                        }),
                        /*#__PURE__*/ _jsx(SortableList, {
                            bi: bi.reorder,
                            items: reorderableEntries,
                            testId: testId,
                            itemClassName: styles.sortableEntry,
                            handleVisibility: "hover",
                            onReorder: (reordered)=>{
                                const columnIds = compact([
                                    mainEntry === null || mainEntry === void 0 ? void 0 : mainEntry.id,
                                    ...reordered.map((entry)=>entry.id)
                                ]);
                                setRowOrder(columnIds);
                                onReorder === null || onReorder === void 0 ? void 0 : onReorder(columnIds);
                            },
                            renderItem: panelRow
                        })
                    ]
                })
            })
        ]
    });
}
